import clsx from "clsx";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { onActivateKeyDown, TOOLTIP_DELAY_BUTTONS } from "@ryde/shared";

import { FramerTooltip } from "../../../tooltips";

interface IRideStationDefaultSupplierPinProps {
  greyDefaultAreaMarkerForSkipWithoutPriorityId?: boolean;
}

export const RideStationDefaultSupplierPin: FC<
  IRideStationDefaultSupplierPinProps
> = ({ greyDefaultAreaMarkerForSkipWithoutPriorityId }) => {
  const { t } = useTranslation();

  return (
    <FramerTooltip
      content={
        greyDefaultAreaMarkerForSkipWithoutPriorityId
          ? t("ride.DEFAULT_AREA_SUPPLIER_NOT_APPLIED_SKIP_RIDE_TYPE")
          : t("ride.AREA_GROUP_WITH_DEFAULT_SUPPLIER")
      }
      mouseEnterDelay={TOOLTIP_DELAY_BUTTONS}
    >
      <span
        className={clsx(
          "area-default-supplier-marker",
          greyDefaultAreaMarkerForSkipWithoutPriorityId &&
            "area-default-supplier-marker--skipped",
        )}
        onClick={e => e.stopPropagation()}
        onKeyDown={onActivateKeyDown(e => e.stopPropagation())}
        role="button"
        tabIndex={0}
      >
        {"\u{1F3F7}\uFE0F"}
      </span>
    </FramerTooltip>
  );
};

export const RideStationDefaultSupplierLookupPin: FC<
  IRideStationDefaultSupplierPinProps
> = ({ greyDefaultAreaMarkerForSkipWithoutPriorityId }) => {
  const { t } = useTranslation();

  return (
    <FramerTooltip
      content={
        <>
          {greyDefaultAreaMarkerForSkipWithoutPriorityId
            ? t("ride.DEFAULT_AREA_SUPPLIER_NOT_APPLIED_SKIP_RIDE_TYPE")
            : t("ride.AREA_GROUP_WITH_DEFAULT_SUPPLIER")}
          <br />
          {t("ride.AREA_GROUP_USED_FOR_SUPPLIER_LOOKUP")}
        </>
      }
      mouseEnterDelay={TOOLTIP_DELAY_BUTTONS}
    >
      <span
        className={clsx(
          "area-default-supplier-marker",
          "area-default-supplier-marker--lookup",
          greyDefaultAreaMarkerForSkipWithoutPriorityId &&
            "area-default-supplier-marker--skipped",
        )}
        onClick={e => e.stopPropagation()}
        onKeyDown={onActivateKeyDown(e => e.stopPropagation())}
        role="button"
        tabIndex={0}
      >
        {"\u{1F3F7}\uFE0F"}
      </span>
    </FramerTooltip>
  );
};
